// Unpublished Work © 2020-2023 Deere & Company.

import {combineReducers} from 'redux';
import {AddCustomerDetail} from '../../state/struct/add-customer/add-customer-detail';
import {reducerTcombWrapper} from '@deere/cap-it-ui.redux-store-creator';
import {customer} from './customer';
import {applicationStatus} from './application-status';
import {domainData} from './domain-data';
import {potentialMatches} from './potential-matches';
import {validationError} from './validation-error';
import {originalCustomerValues} from './confirm-to-change-original-values';
import {dataShare} from './data-share';

export const getAddCustomerCombinedReducer = () => {
    const combinedReducer = combineReducers({
        applicationStatus,
        originalCustomerValues,
        dataShare,
        customer,
        domainData,
        potentialMatches,
        validationError
    });

    return reducerTcombWrapper.bind(
        this,
        {
            combinedReducer,
            stateStruct: AddCustomerDetail
        }
    );
};
